import {
  FETCH_EMISSION_BACKING_ESTIMATE,
  FETCH_EMISSION_BACKING_ESTIMATE_ERROR,
  FETCH_EMISSION_BACKING_ESTIMATE_SUCCESS,
  EmissionBackingEstimateActionTypes,
} from '../../../types/actions/Token/EmissionBackingEstimate.action';
import {IEmissionBackingEstimate} from '../../../types/models/EmissionBackingEstimate';

export interface EmissionBackingEstimateState {
  data: IEmissionBackingEstimate | null;
  isLoading: boolean;
}

const initialState: EmissionBackingEstimateState = {
  data: null,
  isLoading: false,
};

export default (
  state = initialState,
  action: EmissionBackingEstimateActionTypes,
): EmissionBackingEstimateState => {
  switch (action.type) {
    case FETCH_EMISSION_BACKING_ESTIMATE: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case FETCH_EMISSION_BACKING_ESTIMATE_SUCCESS: {
      return {
        isLoading: false,
        data: action.payload,
      };
    }

    case FETCH_EMISSION_BACKING_ESTIMATE_ERROR: {
      return {
        isLoading: false,
        data: null,
      };
    }
    default:
      return state;
  }
};
